import {getCellValue} from "../../../../../../utils/utils";
import {isBetween, isPastDay, MtoJFullDateFormat} from "../../../../../../utils/date";
import Icon from "../../../../general/icon";
import {general} from "../../../../../../store/action";
import {connect, useSelector} from "react-redux";
import React from "react";
import Tooltip from "../../../../general/tooltip";
import {useFindAccessInAccessList} from "../../../../../../constants/constant/accessProcess";

type PatientProgramTableRowItemProps = {
  item: any;
  readonly: boolean;
  handleShowModal: any;
}

const PatientProgramTableRowItem = ({
  item,
  readonly,
  handleShowModal
}: PatientProgramTableRowItemProps) => {

  const isProvider = useSelector((state: any) => state.general.userDataReducer.isProvider);
  const {findAccessInAccessList} = useFindAccessInAccessList();

  const getProgramType = () => {
    let _type = "";
    const isEndedProgram = isPastDay(item?.endDateTime),
      isCurrentProgram = isBetween(new Date() ,item.startDateTime, item.endDateTime),
      isCurrentWithNullToDateProgram = item?.endDateTime == null && isPastDay(item?.startDateTime),
      isFutureProgram = !isPastDay(item.startDateTime);
    if(isEndedProgram) _type = "برنامه پایان یافته";
    else if(isCurrentProgram || isCurrentWithNullToDateProgram) _type = "برنامه جاری";
    else if(isFutureProgram) _type = "برنامه آینده";
    return _type;
  }


  return (
    <tr>
      <td>{getCellValue(item?.program?.name)}</td>
      <td>
        <bdi className="word-spacing-10">{getCellValue(MtoJFullDateFormat(item?.startDateTime))}</bdi>
      </td>
      <td>
        <bdi className="word-spacing-10">{getCellValue(MtoJFullDateFormat(item?.endDateTime))}</bdi>
      </td>
      <td>{getCellValue(item?.location)}</td>
      <td>{getProgramType()}</td>
      {((!readonly && isProvider) || findAccessInAccessList('EHR_VITAL_DELETE')) &&
        <td>
          <div className="d-flex justify-content-center align-items-center">
            <Tooltip alt={'حذف'} className="tooltip-pre-line">
              <span
                onClick={() => handleShowModal('deletePatientProgramModal', item?.id)}
                className="d-flex text-red-hover mx-2 font-20 cur-pointer"
              >
                <Icon name='trash'/>
              </span>
            </Tooltip>
          </div>
        </td>
      }
    </tr>
  )
}

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PatientProgramTableRowItem);
